import { render, staticRenderFns } from "./Alignments.vue?vue&type=template&id=47903b81&scoped=true&"
import script from "./Alignments.vue?vue&type=script&lang=ts&"
export * from "./Alignments.vue?vue&type=script&lang=ts&"
import style0 from "./Alignments.vue?vue&type=style&index=0&id=47903b81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47903b81",
  null
  
)

export default component.exports